import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'slick-carousel';

class Common {
    constructor() {

    }

    init() {
        this.bindEvents();

        if ($('.Retail .mobile-menu-trigger').length) {
            this.initMobileMenu();
        }

        //if ($('.Retail .search-container').length) {
        //    this.initSearchContainer();
        //}

        if ($('.Retail .timeline-container').length) {
            this.initTimeline();
        }

        if ($('.Retail .slick-slider--reviews, .CommunityLending .slick-slider--reviews').length) {
            this.initReviewsSlider();
        }

        if ($('.Retail #google_translate_element').length) {
            this.initGoogleTranslate();        
        }
    }

    bindEvents() {
        $('.form-container').validate();

        // phone mask
        //$('.js-phone-input').mask('(000) 000-0000');

        $('#contact-form').on('submit', e => { this.validateForm(e); });

        $('[data-hasdepending="true"]').on('change', e => { this.toggleDependingForm(e); });

        $(document).on('click', '.notification-bar-close', function () {
            const bar = $(this).closest('.notification-bar')[0];

            if (!bar) {
                return;
            }

            const key = bar.dataset.dismissKey;

            if (!key) {
                return;
            }

            document.cookie = `BannerDismiss-${key}=true; path=/; max-age=${60 * 60 * 24 * 30}`;
            bar.remove();
        });

        $('.slick-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
        });

        $('.slick-slider--testimonials').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: true,
        });

        $('.slick-slider--lendingOptions').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
        });
        
        $('.slick-slider--loans, .slick-slider--loans4').slick({
            slidesToShow: 4,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidestoshow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidestoshow: 2
                    }
                }
            ]
        });

        $('.slick-slider--loans3').slick({
            slidesToShow: 3,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidestoshow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidestoshow: 1
                    }
                }
            ]
        });

        $('.slick-slider--loans2').slick({
            slidesToShow: 2,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidestoshow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidestoshow: 2
                    }
                }
            ]
        });

        $('.slick-slider--loans1').slick({
            slidesToShow: 1,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: false,
            dots: true,
        });

        $('.slick-slider--stateLoansFeatured').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            fade: false,
            autoplay: true,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
        
        $('.slick-slider--stateLoansAll').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            fade: false,
            autoplay: true,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToshow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToshow: 2
                    }
                }
            ]
        });

        $('#all-programs-tab').on('click', function (event) {
            setTimeout(function () {
                $('.slick-slider--stateLoansAll').slick('setPosition'); // Recalculate positions
            }, 100); // Small delay to ensure tab transition is complete
        });

        //three column card widget
        $('.slick-slider--cardThreeColumn').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: false,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        });


        //if ($('#map-canvas').length) {
        //    // lhfs adds a marker to indicate the position
        //    function initialize() {
        //        console.log("initialize");
        //        var mapOptions = {
        //            zoom: 15,
        //            center: new google.maps.LatLng(37.972584, -122.055321)
        //        };
        //    var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
        //    var image = '';
        //    var myLatLng = new google.maps.LatLng(37.972584, -122.055321);
        //    var trafficLayer = new google.maps.TrafficLayer(); trafficLayer.setMap(map);
        //    var contentString = '<div id="content">' +
        //        '</br></br><h6 id="firstHeading" class="firstHeading">Land Home Financial Services, Inc.</h6>' +
        //        '<div id="bodyContent">'
        //    '<p>1355 Willow Way, Suite 250<br>Concord, CA 94520<br>' +
        //        '<a href="https://lhfs.com/" target="_blank">[Web Site]</a> | ' +
        //        '<a href="https://www.google.com/maps/place/1355 Willow Way, Suite 250 Concord, CA 94520" target="_blank">[Larger Map]</a>' +
        //        '</p>'
        //        + '</div></div>';
        //    var infowindow = new google.maps.InfoWindow({
        //        content: contentString,
        //        maxWidth: 400
        //    });
        //    var lhfsMarker = new google.maps.Marker({
        //        animation: google.maps.Animation.DROP,
        //        position: myLatLng,
        //        map: map,
        //        icon: image,
        //        title: 'Land Home Financial Services, Inc.'
        //    });
        //    google.maps.event.addListener(lhfsMarker, 'click', function () {
        //        infowindow.open(map, lhfsMarker);
        //        map.setCenter(lhfsMarker.getPosition());
        //    });
        //    infowindow.open(map, lhfsMarker);
        //    };

        //    initialize();
        //    //window.addEventListener('load', initialize);
        //}

        if ($('.click-to-play').length) {
            $('.click-to-play').on('click', function () {
                const $video = $(this).find('video').get(0); // find the child video element

                // Muted autoplay: first click turns sound on rather than pausing the video.
                if (!$video.paused && $video.muted) {
                    $video.muted = false;
                    return;
                }

                if ($video.paused) {
                    $video.muted = false;
                    // $video.setAttribute('controls', ''); // optional
                    $(this).addClass('playing');
                    $video.play();
                } else {
                    $(this).removeClass('playing');
                    $video.pause();
                }
            });
        }

        $('.Retail .loan-expert-search form').on('submit', function (e) {
            e.preventDefault(); // Stop default form submission
            const inputValue = $('.loan-expert-search input').val().trim();

            if (inputValue) {
                window.location.href = '/loan-officers?query=' + encodeURIComponent(inputValue);
            }
        });
    
    }

    //retail and community lending site reviews slider
    initReviewsSlider() {
        let apiUrl = window.api.apiUrl + "/Testimonial/corp?MinimumRating=5&Page=1&PageSize=10";
        fetch(apiUrl)
            .then(res => res.json())
            .then(data => {
                const slider = document.querySelector('.slick-slider--reviews');
                data.items.forEach(review => {
                    // Create slide container
                    const slide = document.createElement('div');
                    slide.classList.add('slide-container');

                    // Stars container
                    const starsDiv = document.createElement('div');
                    starsDiv.classList.add('stars');

                    // Add 5 star icons
                    for (let i = 0; i < 5; i++) {
                        const star = document.createElement('div');
                        star.classList.add('fas', 'fa-star');
                        starsDiv.appendChild(star);
                    }

                    // Add rating count
                    const count = document.createElement('span');
                    count.classList.add('count');
                    count.textContent = `5/5`;
                    starsDiv.appendChild(count);

                    // Title
                    //const title = document.createElement('div');
                    //title.classList.add('title');
                    //title.textContent = review.Title;

                    // Copy
                    const copy = document.createElement('p');
                    copy.classList.add('copy');
                    copy.textContent = review.description;

                    // Author
                    const author = document.createElement('div');
                    author.classList.add('author');
                    author.textContent = review.customerFirstName + " " + review.customerLastName + ", " + review.transactionState;

                    // Append all to slide
                    slide.appendChild(starsDiv);
                    //slide.appendChild(title);
                    slide.appendChild(copy);
                    slide.appendChild(author);

                    // Add slide to slider
                    slider.appendChild(slide);
                });

                // Initialize Slick after DOM update
                $('.slick-slider--reviews').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: false,
                    autoplay: false,
                    infinite: false,
                    variableWidth: false,
                    adaptiveHeight: true,
                    dots: true,
                });
            });
    }


    //Retail site mobile menu
    initMobileMenu() {
        const trigger = document.querySelector('.Retail .mobile-menu-trigger');
        const menu = document.querySelector('.Retail .menu-container');

        if (trigger && menu) {
            // Toggle menu on trigger click
            trigger.addEventListener('click', function (e) {
                e.stopPropagation(); // Prevent click from bubbling up to document
                trigger.classList.toggle('open');
                menu.classList.toggle('open');
            });

            // Prevent menu clicks from bubbling to document
            menu.addEventListener('click', function (e) {
                e.stopPropagation();
            });

            // Close menu and trigger on outside click
            document.addEventListener('click', function () {
                if (trigger.classList.contains('open')) {
                    trigger.classList.remove('open');
                    menu.classList.remove('open');
                }
            });
        }

        //mobile menu dropdowns
        const dropdownItems = document.querySelectorAll(".Retail li.has-dropdown");

        dropdownItems.forEach(function (item) {
            const link = item.querySelector("a");

            if (link) {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    item.classList.toggle("open");
                });
            }
        });
    }

    initGoogleTranslate() {
        // Trigger Spanish translation when the button is clicked
        function triggerSpanishTranslation() {
            var interval = setInterval(function () {
                var select = document.querySelector("select.goog-te-combo");
                if (select) {
                    select.value = 'es'; // 'es' is the language code for Spanish
                    select.dispatchEvent(new Event('change'));
                    clearInterval(interval);
                }
            }, 500);
        }

        document.getElementById('translate-button').addEventListener('click', function () {
            triggerSpanishTranslation();
        });
    }

    initSearchContainer() {
        const searchContainer = document.querySelector(".search-container");
        const searchBoxTrigger = document.getElementById("search-container-trigger");
        const searchCloseTrigger = document.getElementById("search-close-trigger");

        searchBoxTrigger.addEventListener("click", function () {
            searchContainer.classList.add("open");
        });

        searchCloseTrigger.addEventListener("click", function () {
            searchContainer.classList.remove("open");
        });
    }

    initTimeline() {
        const items = document.querySelectorAll('.timeline-itemCircle');
        const contents = document.querySelectorAll('.timeline-itemContent');
        const container = document.querySelector('.timeline-container');

        items.forEach((item, index) => {
            item.addEventListener('click', () => {
                const year = item.getAttribute('data-year');
                const content = document.getElementById('year-' + year);

                // Hide all content boxes
                contents.forEach(c => c.classList.remove('active'));

                // Remove active class from all circles
                items.forEach(i => i.classList.remove('active'));

                // Add active class to clicked circle
                item.classList.add('active');

                // Show the corresponding content box
                content.classList.add('active');

                // Set positioning
                content.style.position = 'absolute';

                const totalItems = items.length;
                const isSecondHalf = index >= Math.ceil(totalItems / 2);

                if (window.innerWidth <= 768) {
                    // Mobile: always position to right with fixed offset
                    content.style.left = '55px';
                    content.style.right = 'auto';
                    content.style.bottom = isSecondHalf ? '-15px' : 'auto';
                    content.style.top = isSecondHalf ? 'auto' : '-15px';
                } else {
                    // Desktop: use left/right based on index
                    content.style.left = isSecondHalf ? 'auto' : '-30px';
                    content.style.right = isSecondHalf ? '-30px' : 'auto';
                }
            });
        });
    }

    conditionallyRequiredToggle(parentValue, item) {
        $(item).each((index, formGroup) => {
            let $formInput = $(formGroup).find('.conditionally-required');
            $formInput.attr('required', parentValue);

            if (!parentValue) {
                $formInput.removeClass('input-validation-error');

                let $errorContainer = $formInput.siblings('span.error');
                $errorContainer.removeClass('field-validation-error').addClass('field-validation-valid');
            }
        });
    }

    toggleDependingForm(e) {
        let value = $(e.currentTarget).val();
        let name = $(e.currentTarget).attr('name').replace( 'Form.', '' );

        let questions = $(`[data-dependingquestion="${name}"]`);

        $(questions).each((index, item) => {
            if (Array.isArray(value)) {
                if (value.includes($(item).data('dependinganswer'))) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
            else {
                if (value.toLowerCase().indexOf($(item).data('dependinganswer').toLowerCase()) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }

            //handle depending answer being multiple options
            let dependingAnswer = $(item).data('dependinganswer');
            if (dependingAnswer.includes(',')) {
                const answers = dependingAnswer.split(',');
                if ($.inArray(value, answers) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
        });
    }

    validateForm(e) {
        if ($('#recaptcha_contact')[0] && grecaptcha.getResponse().length === 0) {
            e.preventDefault();
            $('#recaptcha_contact').next().show();
            return false;
        }
        else {
            if ($('#recaptcha_contact')[0]) {
                $('#recaptcha_contact').next().hide();
            }
            return true;
        }
    }
}

export default Common;